// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"T1-z","displaySixCardTiles":"U1-z"};